import React, {Component} from "react";
import {Divider, Typography} from "@mui/material";
import {AppRow} from "../components/components";

const r2 = (n) => (n === undefined || n === null) ? "-" : Math.round((n + Number.EPSILON) * 100) / 100;
const pct = (n) => (n === undefined || n === null) ? "-" : (Math.round(n * 1000) / 10) + "%";

/**
 * Compact global readout of the seam diagnostic (diagnostic_summary.json):
 * the rigid / systematic / noise breakdown, field RMS, repeatability, the
 * de-noised per-seam RMS, and the verdict. Pairs with the SeamDistortion
 * per-seam overlays.
 */
class SeamDiagnosticSummary extends Component {
    render() {
        let {seamDiagnosticSummary, slide} = this.props;
        if (!seamDiagnosticSummary || !seamDiagnosticSummary.overall)
            return <div align={"right"}/>;

        let upp = (slide && slide.uperpixel) ? slide.uperpixel : 0;
        let um = (px) => (px === undefined || px === null) ? "-"
            : (upp ? `${r2(px)}px / ${r2(px * upp)}um` : `${r2(px)}px`);

        let o = seamDiagnosticSummary.overall;
        let lr = seamDiagnosticSummary.left_right;
        let tb = seamDiagnosticSummary.top_bottom;
        let ps = seamDiagnosticSummary.per_seam_overall;
        let bias = o.mean_bias_px || [];

        return <div>
            <Typography color={"whitesmoke"} sx={{paddingX: 1, fontWeight: 600}}>Seam Diagnostic</Typography>
            <AppRow title={"Per-window RMS"} value={um(o.rms_residual_px)}/>
            {ps && <AppRow title={"Per-seam RMS"} value={um(ps.rms_residual_px)}/>}
            <AppRow title={"Rigid/Sys/Noise"}
                    value={`${pct(o.rigid_fraction)} / ${pct(o.systematic_fraction)} / ${pct(o.noise_fraction)}`}/>
            <AppRow title={"Field RMS (sys)"} value={um(o.systematic_field_rms_px)}/>
            <AppRow title={"Repeatability"} value={r2(o.repeatability)}/>
            <AppRow title={"Mean bias (dx,dy)"} value={`${r2(bias[0])}, ${r2(bias[1])} px`}/>
            <Divider sx={{my: 0.5}}/>
            {lr && <AppRow title={"LR field / rep"}
                           value={`${r2(lr.systematic_field_rms_px)}px / ${r2(lr.repeatability)}`}/>}
            {tb && <AppRow title={"TB field / rep"}
                           value={`${r2(tb.systematic_field_rms_px)}px / ${r2(tb.repeatability)}`}/>}
            <Typography color={"whitesmoke"} sx={{paddingX: 1, fontSize: "0.72rem", mt: 0.5}}>
                {seamDiagnosticSummary.overall_verdict}
            </Typography>
        </div>;
    }
}

export default SeamDiagnosticSummary;
